import { lookupRsvpCode, recordResponses } from '../../services/RsvpService.js';

export const RSVP_LOOKUP_INITIATED = 'RSVP_LOOKUP_INITIATED';
export const RSVP_LOOKUP_FAILED = 'RSVP_LOOKUP_FAILED';
export const RSVP_LOOKUP_SUCCEEDED = 'RSVP_LOOKUP_SUCCEEDED';
export const RSVP_RESPONSE_INITIATED = 'RSVP_RESPONSE_INITIATED';
export const RSVP_RESPONSE_FAILED = 'RSVP_RESPONSE_FAILED';
export const RSVP_RESPONSE_SUCCEEDED = 'RSVP_RESPONSE_SUCCEEDED';

export const initiateRsvpLookup = () => ({
  type: RSVP_LOOKUP_INITIATED
});

export const flagRsvpLookupFailure = () => ({
  type: RSVP_LOOKUP_FAILED
});

export const flagRsvpLookupSuccess = (invitation) => ({
  type: RSVP_LOOKUP_SUCCEEDED,
	payload: invitation
});

export const initiateRsvpResponse = () => ({
  type: RSVP_RESPONSE_INITIATED
});

export const flagRsvpResponseFailure = () => ({
  type: RSVP_RESPONSE_FAILED
});

export const flagRsvpResponseSuccess = () => ({
  type: RSVP_RESPONSE_SUCCEEDED
});

const lookupRsvpAction = (rsvpCode) => {
	return async (dispatch) => {
		dispatch(initiateRsvpLookup());
		lookupRsvpCode(rsvpCode)
			.then(result => {
				result
				? dispatch(flagRsvpLookupSuccess(result))
				: dispatch(flagRsvpLookupFailure())
			})
			.catch((e) => {
		    dispatch(flagRsvpResponseFailure())
			});
	}
}

const recordResponsesAction = (rsvpCode, guestResponses) => {
	return async (dispatch) => {
		dispatch(initiateRsvpResponse());
		recordResponses(rsvpCode, guestResponses)
			.then(result => {
				result
				? dispatch(flagRsvpResponseSuccess())
		  : dispatch(flagRsvpResponseFailure())
			})
			.catch((e) => {
		    dispatch(flagRsvpResponseFailure())
			});
	}
}

export { lookupRsvpAction as lookupRsvp };
export { recordResponsesAction as recordResponses };



// WEBPACK FOOTER //
// ./state/actions/RsvpActions.js